module.exports = __webpack_public_path__ + "img/icon5.396f8400.png";